import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-293d3da6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contactWrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我的设备", -1))
const _hoisted_3 = { class: "itemsWrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我的好友", -1))
const _hoisted_5 = { class: "itemsWrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我的群组", -1))
const _hoisted_7 = { class: "itemsWrap" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我的聊天室", -1))
const _hoisted_9 = { class: "itemsWrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_ContactItem = _resolveComponent("ContactItem")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavBar, { title: "Contact" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.deviceList, (item, idx) => {
          return (_openBlock(), _createBlock(_component_ContactItem, {
            key: item,
            name: item,
            isEnd: idx >= _ctx.contact.deviceList.length - 1,
            chatType: "singleChat"
          }, null, 8, ["name", "isEnd"]))
        }), 128))
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.userList, (item, idx) => {
          return (_openBlock(), _createBlock(_component_ContactItem, {
            key: item,
            name: item,
            isEnd: idx >= _ctx.contact.userList.length - 1,
            chatType: "singleChat"
          }, null, 8, ["name", "isEnd"]))
        }), 128))
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.groupList, (item, idx) => {
          return (_openBlock(), _createBlock(_component_ContactItem, {
            key: item.groupid,
            name: item.groupid,
            isEnd: idx >= _ctx.contact.groupList.length - 1,
            chatType: "groupChat"
          }, null, 8, ["name", "isEnd"]))
        }), 128))
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.roomList, (item, idx) => {
          return (_openBlock(), _createBlock(_component_ContactItem, {
            key: item.id,
            name: item.id,
            isEnd: idx >= _ctx.contact.roomList.length - 1,
            chatType: "chatRoom"
          }, null, 8, ["name", "isEnd"]))
        }), 128))
      ])
    ])
  ]))
}